import React from "react";
import { iconProps } from "../../../Helper";

export const PromptEngineerIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask
        id="mask0_9578_5843"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_9578_5843)">
        <path
          className={className}
          d="M6.19758 9.3075L8.00008 8.214L9.80258 9.3075L9.32441 7.2575L10.9231 5.87934L8.81925 5.70234L8.00008 3.76917L7.18091 5.70234L5.07708 5.87934L6.67575 7.2575L6.19758 9.3075ZM1.66675 14.0255V2.87167C1.66675 2.53489 1.78341 2.24984 2.01675 2.0165C2.25008 1.78317 2.53514 1.6665 2.87191 1.6665H13.1282C13.465 1.6665 13.7501 1.78317 13.9834 2.0165C14.2167 2.24984 14.3334 2.53489 14.3334 2.87167V10.4613C14.3334 10.7981 14.2167 11.0832 13.9834 11.3165C13.7501 11.5498 13.465 11.6665 13.1282 11.6665H4.02575L1.66675 14.0255ZM3.60008 10.6665H13.1282C13.1796 10.6665 13.2266 10.6451 13.2692 10.6023C13.312 10.5597 13.3334 10.5127 13.3334 10.4613V2.87167C13.3334 2.82034 13.312 2.77334 13.2692 2.73067C13.2266 2.68789 13.1796 2.6665 13.1282 2.6665H2.87191C2.82058 2.6665 2.77358 2.68789 2.73091 2.73067C2.68814 2.77334 2.66675 2.82034 2.66675 2.87167V11.5897L3.60008 10.6665Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
